export default __webpack_public_path__ + "static/Localizacao-d38413588c3153803111004039febb45.svg";